import { render, staticRenderFns } from "./link-tasks-drawer.vue?vue&type=template&id=a0264f2a&"
import script from "./link-tasks-drawer.vue?vue&type=script&lang=ts&"
export * from "./link-tasks-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./link-tasks-drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports